
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, Action } from 'redux';
import { AppStates } from '../../reducers/app';
import { UIModeState } from '../../reducers/uimode';
import { ToolbarDirection } from '../../actions/UIModeAction';
import { mapStateToZoomable, getScale, getInitialScale } from '../../selectors/zoomingSelector';
import { tabFocusSelf } from '../../reducers/pages';
import { Slider } from './Slider';
import * as ViewAction from '../../actions/ViewAction';
import IconButton from './IconButton';
import { maxZoomRate } from '../../constants';

interface NewZoomSliderProps {
  readonly roundRectButton?: boolean;
  readonly activePanelID: string;
  readonly zoomingEnabled: boolean;
  readonly zoomInEnabled: boolean;
  readonly zoomOutEnabled: boolean;
  readonly scale: number;
  readonly baseScale: number;
  readonly uimode: UIModeState;
  readonly dispatch: Dispatch<Action>;
}

const minValue = 1;
const maxValue = maxZoomRate;

const gripStyle: React.CSSProperties = {
  backgroundColor: 'transparent',
  backgroundImage: 'url("images/tool-icons/new/seamless_zoom_tab/seamless_zoom_tab_out.png")',
  backgroundSize: 'contain',
  border: 'none',
};

const NewZoomSlider: React.SFC<NewZoomSliderProps> = React.memo((props) => {
  const {
    roundRectButton, zoomingEnabled, uimode, activePanelID, dispatch, scale, baseScale,
  } = props;
  const { toolbarDirection } = uimode;
  const vertical = toolbarDirection !== ToolbarDirection.Horizontal;
  const value = scale / baseScale;

  return (
    <Slider
      vertical={vertical}
      enabled={zoomingEnabled}
      gripSize={20}
      gripStyle={gripStyle}
      value={value}
      onChange={(value) => {
        dispatch(ViewAction.setZoom(activePanelID, value * baseScale));
      }}
      renderIncrementButton={() => {
        return (
          <IconButton
            title="拡大"
            imagePath="images/tool-icons/new/seamless_zoom/seamless_zoom_plus"
            rouondRect={roundRectButton}
            disabled={!props.zoomInEnabled}
            onClick={() => {
              dispatch(ViewAction.zoomIn(activePanelID));
            }} />
        );
      }}
      renderDecrementButton={() => {
        return (
          <IconButton
            title="縮小"
            imagePath="images/tool-icons/new/seamless_zoom/seamless_zoom_minus"
            rouondRect={roundRectButton}
            disabled={!props.zoomOutEnabled}
            onClick={() => {
              dispatch(ViewAction.zoomOut(activePanelID));
            }} />
        );
      }}
      minValue={minValue}
      maxValue={maxValue} />
  );
});

const mapStateToProps = (appStates: AppStates) => {
  const { pages } = appStates;
  const tab = pages.tabs[pages.activeTab];
  const panelID = tab.focus === tabFocusSelf ? tab.id : tab.focus;

  return {
    ...mapStateToZoomable(appStates, { panelID }),
    scale: getScale(appStates, { panelID }),
    baseScale: getInitialScale(appStates, { panelID }),
    activePanelID: panelID,
    uimode: appStates.uimode,
  };
};

export default connect(mapStateToProps)(NewZoomSlider);
